export default __webpack_public_path__ + "static/flyer1@2x-d66fc9f096f7b9ed851eaacbf9d3ce1a.jpg";